import { useRef } from 'react'
import { Link } from 'react-router'
import logo from './logo.svg'

export const HeaderNav: React.FC = () => {
  const checkbox = useRef<HTMLInputElement>(null)

  const closeMenu = () => {
    if (checkbox.current) {
      checkbox.current.checked = false
    }
  }

  return (
    <header className="group sticky top-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray/30">
      <div className="max-w-5xl mx-auto px-5 h-14 flex items-center justify-between">
        <a href="/">
          <img src={logo} alt="FLOWER" className="h-7" />
        </a>
        <nav className="hidden md:flex items-center gap-8 text-[13px] text-dark-gray">
          <a href="#pricing" className="hover:text-main transition-colors">
            料金プラン
          </a>
          <a href="#faq" className="hover:text-main transition-colors">
            よくある質問
          </a>
          <Link reloadDocument to="/subscription/branch/mypage" className="hover:text-main transition-colors">
            マイページ
          </Link>
        </nav>
        <label htmlFor="green-nav-toggle" className="md:hidden text-main cursor-pointer" aria-label="メニュー">
          <svg
            className="group-has-[input:checked]:hidden"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          >
            <line x1="3" y1="7" x2="21" y2="7" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="17" x2="21" y2="17" />
          </svg>
          <svg
            className="hidden group-has-[input:checked]:block"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          >
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="6" y1="18" x2="18" y2="6" />
          </svg>
          <input type="checkbox" id="green-nav-toggle" hidden ref={checkbox} />
        </label>
      </div>
      <div className="grid grid-rows-[0fr] group-has-[input:checked]:grid-rows-[1fr] transition-[grid-template-rows] duration-200 ease-in-out md:grid-rows-[0fr]!">
        <div className="overflow-hidden border-gray/30 bg-white">
          <div className="px-5 py-6 space-y-4 text-sm border-t border-gray/30">
            <a href="#pricing" className="block text-main" onClick={closeMenu}>
              料金
            </a>
            <a href="#faq" className="block text-main" onClick={closeMenu}>
              よくある質問
            </a>
            <Link reloadDocument to="/subscription/branch/mypage" className="block text-main" onClick={closeMenu}>
              マイページ
            </Link>
          </div>
        </div>
      </div>
    </header>
  )
}
